/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { uniqBy, map, isEqual } from 'lodash';
import CargomaticCard from 'components/v2/card';
import { retrieveRailsightShipperStatus, retrieveContainerStatus, updateContainerDetails, } from 'utils/ContainerTrackAPIUtils';
import moment from 'moment';
import ToastStore from 'stores/ToastStore';
import { humanize, titleize } from 'underscore.string';
import Badge from 'components/v2/Badge';
import CircleButton from 'components/v2/buttons/CircleButton';
import RefreshIcon from 'components/v2/icons/RefreshIcon';
import LoadingCircle from 'components/ui/LoadingCircle';
import { withTranslation } from 'react-i18next';
import formatMoney from 'utils/formatters/Money';
import { getOpentrackTrackingInfo } from 'utils/opentrack-utils';
import Alert from 'components/ui/Alert';
import { OPENTRACK_FAILURE_REASONS, OPENTRACK_TRACKING_STATUS } from 'constants/Opentrack';
import { RAILSIGHT_STATUS } from 'constants/Railsight';
import DescriptionListItem from '../../v2/DescriptionListItem';
class PortIntegration extends Component {
    constructor(props) {
        super(props);
        this.setRefreshFunction = () => {
            this.refreshFunction = setInterval(async () => {
                this.getContainerData();
            }, 20000);
        };
        this.renderHolds = (holds) => {
            const { t } = this.props;
            return holds.map((hold, i) => {
                return (React.createElement("ul", { key: i },
                    React.createElement("li", null,
                        t('REPORTED_WITH_VALUE', {
                            value: hold.reported_at
                                ? moment(hold.reported_at).format('L')
                                : t('NOT_AVAILABLE'),
                        }),
                        React.createElement("br", null),
                        t('TYPE_WITH_VALUE', {
                            value: hold.type ? hold.type : t('NOT_AVAILABLE'),
                        }),
                        React.createElement("br", null),
                        t('RESOLVED_WITH_VALUE', {
                            value: hold.resolved_at
                                ? moment(hold.resolved_at).format('L')
                                : t('NOT_AVAILABLE'),
                        }))));
            });
        };
        this.getRailsightStatus = async () => {
            var _a;
            const { data: shipment, isShipment, t } = this.props;
            if (isShipment) {
                try {
                    const railSightActive = await retrieveRailsightShipperStatus(((_a = shipment.shipper) === null || _a === void 0 ? void 0 : _a.id) || shipment.shipper);
                    this.setState({ railSightActive });
                }
                catch (err) {
                    this.showNotification(t('RAILSIGHT_STATUS_FAILED'), 'fail');
                }
            }
        };
        this.getContainerData = async () => {
            const { containers, masterBol } = this.state;
            await this.queryContainerData(containers, masterBol);
        };
        this.renderTooltip = (item) => {
            const { t } = this.props;
            return (React.createElement(Tooltip, { id: "button-tooltip", style: { width: 300 } },
                React.createElement("div", { className: "text-left" },
                    t('ETA_WITH_VALUE', {
                        value: (item === null || item === void 0 ? void 0 : item.eta_at_terminal)
                            ? moment(item.eta_at_terminal).format('L')
                            : t('NOT_AVAILABLE'),
                    }),
                    React.createElement("br", null),
                    t('ARRIVAL_WITH_VALUE', {
                        value: (item === null || item === void 0 ? void 0 : item.vessel_arrived_date)
                            ? moment(item.vessel_arrived_date).format('L')
                            : t('NOT_AVAILABLE'),
                    }),
                    React.createElement("br", null),
                    t('DISCHARGED_WITH_VALUE', {
                        value: (item === null || item === void 0 ? void 0 : item.discharged_date)
                            ? moment(item.discharged_date).format('L')
                            : t('NOT_AVAILABLE'),
                    }),
                    React.createElement("br", null),
                    t('LFD_WITH_VALUE', {
                        value: (item === null || item === void 0 ? void 0 : item.last_free_day)
                            ? moment(item.last_free_day).format('L')
                            : t('NOT_AVAILABLE'),
                    }),
                    React.createElement("br", null),
                    t('OUTGATED_WITH_VALUE', {
                        value: (item === null || item === void 0 ? void 0 : item.outgated_date)
                            ? moment(item.outgated_date).format('L')
                            : t('NOT_AVAILABLE'),
                    }),
                    React.createElement("br", null),
                    t('EMPTY_WITH_VALUE', {
                        value: (item === null || item === void 0 ? void 0 : item.empty_returned_date)
                            ? moment(item.empty_returned_date).format('L')
                            : t('NOT_AVAILABLE'),
                    }),
                    React.createElement("br", null),
                    item.holds && item.holds.length > 0 && (React.createElement("div", null,
                        titleize(t('HOLD', { count: 2 })),
                        ":",
                        this.renderHolds(item.holds))))));
        };
        this.queryContainerData = async (containers, masterBol) => {
            if (containers && containers.length) {
                try {
                    const response = await retrieveContainerStatus(map(containers, 'equipment_id'), masterBol);
                    if (response &&
                        response.success === true &&
                        response.results &&
                        response.results.length) {
                        this.setState({
                            updates: response.results,
                        });
                    }
                }
                catch (err) {
                    console.log('Failed to retrieve server status', err);
                }
            }
        };
        this.updateContainer = (data) => {
            const { updates: currentData } = this.state;
            const containerToUpdateIndex = currentData.findIndex((container) => container._id === data._id);
            currentData[containerToUpdateIndex] = data;
            this.setState({ updates: currentData });
        };
        this.renderRefresh = (item, update) => {
            const { isRefreshing } = this.state;
            if (isRefreshing) {
                return React.createElement(LoadingCircle, null);
            }
            const difference = moment().diff(moment(item.last_updated), 'minutes');
            const canRefresh = difference > 5;
            return (React.createElement("div", { className: "flex ml-4" },
                React.createElement(CircleButton, { color: "blue", disabled: !canRefresh, onClick: () => {
                        this.refreshContainer(item.container_id, update.master_bill_number);
                    } },
                    React.createElement(RefreshIcon, { size: "medium" }))));
        };
        this.renderHeader = (updates, opentrackMeta, t) => {
            const update = updates.length ? updates[0] : null;
            const { isShipment } = this.props;
            const { railSightActive } = this.state;
            const { localizationSlug, badgeColor } = this.getHeaderStatus(opentrackMeta, update);
            const railsightStatus = this.getHeaderRailsightStatus(update, t);
            return (React.createElement("div", { className: "flex" },
                React.createElement("h3", { className: "my-0 mr-4" }, t('PORT_INTEGRATIONS')),
                React.createElement(Badge, { className: "mt-1", color: badgeColor }, t(localizationSlug)),
                isShipment && railSightActive && (React.createElement(Badge, { className: "mt-1", color: railsightStatus.badgeColor }, railsightStatus.status))));
        };
        this.state = this.getInitialState();
        this.refreshFunction = null;
    }
    getInitialState() {
        const { isShipment } = this.props;
        const containers = this.getContainers(this.props);
        const masterBol = this.getMasterBol(this.props);
        return {
            updates: [],
            railSightActive: false,
            isShipment,
            containers,
            isRefreshing: false,
            masterBol
        };
    }
    parseContainersFromShipments(stops = []) {
        if (stops.length === 0) {
            return [];
        }
        return uniqBy(stops.reduce((equipmentList, stop) => {
            const stopContainers = (stop.equipments || []).filter((eq) => eq._equipmentType === 'container');
            return equipmentList.concat(stopContainers);
        }, []), (eq) => eq._id);
    }
    parseContainersFromOrders(containers = []) {
        if (containers.length === 0) {
            return [];
        }
        let uniqueContainers = uniqBy(containers, '_id');
        uniqueContainers = uniqueContainers.filter((eq) => eq._equipmentType === 'container');
        return uniqueContainers;
    }
    getContainers(props) {
        const { data, isShipment } = props;
        let stops;
        if (isShipment) {
            stops = data.stops;
        }
        else {
            return this.parseContainersFromOrders(data.equipments);
        }
        return this.parseContainersFromShipments(stops);
    }
    getMasterBol(props) {
        var _a;
        const { data, isShipment } = props;
        if (!isShipment || !(data === null || data === void 0 ? void 0 : data.reference_numbers)) {
            return null;
        }
        const { reference_numbers } = data;
        return (_a = reference_numbers.find(r => r.name === 'master_bol')) === null || _a === void 0 ? void 0 : _a.optimized;
    }
    componentDidMount() {
        this.setRefreshFunction();
        this.getContainerData();
        this.getRailsightStatus();
    }
    componentDidUpdate(prevProps) {
        var _a;
        const prevId = (_a = prevProps.data) === null || _a === void 0 ? void 0 : _a._id;
        const prevIsShipment = prevProps.isShipment;
        const { isShipment, data } = this.props;
        const id = data === null || data === void 0 ? void 0 : data._id;
        if (prevIsShipment !== isShipment || prevId !== id) {
            clearInterval(this.refreshFunction);
            const containers = this.getContainers(this.props);
            this.setState({
                containers,
                isShipment,
            }, () => {
                this.setRefreshFunction();
                this.getRailsightStatus();
                this.getContainerData();
            });
        }
    }
    componentWillUnmount() {
        clearInterval(this.refreshFunction);
    }
    getStatusColor(status) {
        if (!status) {
            return 'gray';
        }
        switch (status) {
            case 'VESSEL_ARRIVED':
            case 'DISCHARGED':
                return 'orange';
            case 'LOADED':
            case 'FULL_OUTGATED':
            case 'FULL_INGATED':
            case 'VESSEL_DEPARTED':
                return 'blue';
            case 'AVAILABLE':
            case 'HOLD':
                return 'red';
            default:
                return 'gray';
        }
    }
    getTrackingStoppedFailureText(failureReason, t) {
        switch (failureReason) {
            case OPENTRACK_FAILURE_REASONS.UNTRACKABLE_CONTAINER:
                return t('UNTRACKABLE_CONTAINER');
            case OPENTRACK_FAILURE_REASONS.UNTRACKABLE_BOL:
                return t('UNTRACKABLE_BOL');
            case OPENTRACK_FAILURE_REASONS.NO_MORE_REPORTS:
                return t('NO_MORE_REPORTS');
            case OPENTRACK_FAILURE_REASONS.OUTDATED_SHIPMENT:
                return t('OUTDATED_SHIPMENT');
            default:
                return failureReason;
        }
    }
    showNotification(title, level) {
        ToastStore.getNotifications().push({
            title,
            body: '',
            level,
        });
        ToastStore.emitChange();
    }
    async refreshContainer(container, masterBol) {
        const { t } = this.props;
        try {
            this.setState({ isRefreshing: true });
            const response = await updateContainerDetails(container, masterBol);
            if (response && response.success) {
                this.updateContainer(response.data);
                this.showNotification(t('CONTAINER_REFRESHED_SUCCESSFULLY'), 'success');
                this.setState({ isRefreshing: false });
            }
        }
        catch (err) {
            this.showNotification(t('CONTAINER_REFRESHED_FAILED'), 'fail');
            this.setState({ isRefreshing: false });
        }
    }
    renderTrackingStopped(container_id, failureReason, t) {
        const failureMessage = this.getTrackingStoppedFailureText(failureReason, t);
        return (React.createElement(Alert, { className: "m-4", type: "warning", title: t('STOPPED_TRACKING') }, failureMessage));
    }
    renderRow(updates) {
        const update = updates[0];
        const { t } = this.props;
        return updates
            .filter((x) => !x.is_tracking_stopped)
            .map((item) => (React.createElement("tr", { key: item.container_id },
            React.createElement("td", { className: "w-8" }, item.container_id),
            React.createElement("td", { className: "w-8" },
                React.createElement(OverlayTrigger, { placement: "top", delay: 250, overlay: this.renderTooltip(item) },
                    React.createElement("div", null,
                        React.createElement(Badge, { color: this.getStatusColor(item.status) }, humanize(item.status))))),
            React.createElement("td", { className: "w-10 px-4" }, moment(item.last_updated).format('MMMM Do YYYY, h:mm:ss a')),
            React.createElement("td", { className: "w-8" }, this.renderRefresh(item, update)))));
    }
    getHeaderRailsightStatus(update, t) {
        return {
            status: t(RAILSIGHT_STATUS.RAILSIGHT_ENABLED),
            badgeColor: 'green',
        };
    }
    getHeaderStatus(opentrackMeta, update) {
        return getOpentrackTrackingInfo(opentrackMeta === null || opentrackMeta === void 0 ? void 0 : opentrackMeta.status, update);
    }
    renderBody(updates, opentrackMeta, t) {
        if (updates.length === 0) {
            if (opentrackMeta === null || opentrackMeta === void 0 ? void 0 : opentrackMeta.failure_reason) {
                return this.renderTrackingStopped(opentrackMeta.container_id, opentrackMeta.failure_reason, t);
            }
            return updates.length === 0 && (React.createElement("p", { className: "px-4 py-4 sm:px-6 sm:py-6" }, t('NO_UPDATES')));
        }
        return (React.createElement(React.Fragment, null,
            updates
                .filter((x) => x.is_tracking_stopped)
                .map((x) => this.renderTrackingStopped(x.container_id, x.tracking_stopped_reason, t)),
            updates.filter((x) => !x.is_tracking_stopped).length > 0 && (React.createElement("div", { className: "overflow-x-auto" },
                React.createElement("table", { className: "default-table" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { className: "" }, titleize(t('NUMBER'))),
                            React.createElement("th", { className: "" }, titleize(t('STATE'))),
                            React.createElement("th", { className: "" }, titleize(t('UPDATED'))),
                            React.createElement("th", { className: "" }, titleize(t('REFRESH'))))),
                    React.createElement("tbody", null, this.renderRow(updates)))))));
    }
    render() {
        var _a;
        const { t, isShipment, data: { opentrack_metadata: opentrackMeta }, } = this.props;
        const { updates } = this.state;
        return (React.createElement(CargomaticCard, { header: () => this.renderHeader(updates, opentrackMeta, t), removeHorizontalPadding: true, removeVerticalPadding: true },
            this.renderBody(updates, opentrackMeta, t),
            React.createElement("hr", { className: "my-4" }),
            isShipment && ((_a = this.props.data) === null || _a === void 0 ? void 0 : _a.demurrage_incurred) && (React.createElement(DescriptionListItem, { className: "pl-5 pb-2", label: t('ESTIMATED_DEMURRAGE_OWED') },
                React.createElement("div", { className: "text-lg font-medium text-gray-800" }, formatMoney(this.props.data.demurrage_incurred || 0, this.props.data.currency || 'USD'))))));
    }
}
PortIntegration.propTypes = {
    isShipment: PropTypes.bool.isRequired,
    data: PropTypes.object.isRequired,
};
export default withTranslation()(PortIntegration);
